// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__14RxK","rootCenter":"LoadMoreObserver_rootCenter__3kkre","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1iA3Q"};